import { ControlInterface } from 'edocatbase/Form';
import { Dispatch } from 'redux';
import ContactsModal from './ContactsModal';
import {  Button  } from "@mui/material";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleModal } from '../../../../ModalTest/actions';

interface TextFieldInterface extends ControlInterface {
	multiline: boolean;
	actions: any;
	formInstanceId: string;
	contactsModal: any;
	view: boolean;
}

// @ts-ignore
class AresField extends window.React.PureComponent<TextFieldInterface> {
	handleContacts = (index: number) => {
		const { actions, formInstanceId, name } = this.props;
		actions.toggleModal(true, name, { index }, formInstanceId);
	};

	render() {
		const { value, contactsModal, formInstanceId, name, view, className } = this.props;
		return (
			<React.Fragment>
				{value?.map((it: any, index: number) => (
					<div className="aresCompanySet--View" key={index}>
						{Object.keys(it).map((item: string, innerIndex: number) =>
							item !== 'contacts' && item !== 'aresError' ? (
								<div className={`form-row row-${name} simple-row`} key={`${index}${innerIndex}`}>
									<label>{window.Alfresco.messages.global[`edocat.forms.${item}`]}</label>
									<div
										id={name}
										dangerouslySetInnerHTML={{
											__html: it?.[item] || it?.[item] === 0 ? it?.[item] : window.Alfresco.messages.global['label.none'],
										}}
									/>
								</div>
							) : null
						)}
						<div className={`form-row row-${name} simple-row`}>
							<label>{window.Alfresco.messages.global['edocat.forms.contacts']}</label>
							<div>
								<Button variant="outlined" onClick={() => this.handleContacts(index)} size="small">
									{window.Alfresco.messages.global['edocat.forms.show-table']}
								</Button>
							</div>
						</div>
					</div>
				))}
				{contactsModal.isOpen && /* contactsModal?.items?.index == index && */ (
					<ContactsModal
						{...{ index: contactsModal?.items?.index, name, value, contactsModal, view, formInstanceId }}
					/>
				)}
			</React.Fragment>
		)
	}
}

const mapStateToProps = (state: any, props: any) => {
	const contactsModal = state?.[props.formInstanceId]?.formModal?.[props.name] || {};
	return {
		contactsModal,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ toggleModal }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AresField);
